import React from "react";
import { FaSearch, FaBullhorn, FaUserSlash, FaExclamationTriangle, FaExchangeAlt, FaCoins } from "react-icons/fa";

const ChatSupport = () => {
  return (
    <div className="bg-slate-100 rounded-lg max-w-3xl mx-auto px-6 py-8 space-y-8 my-4">
      {/* Title */}
      <h2 className="text-lg font-semibold">Chat Assistant</h2>

      {/* Search bar */}
      <div className="relative">
        <FaSearch className="absolute left-3 top-3" />
        <input
          type="text"
          placeholder= "This APP not working properly at my mobile"
          className="w-full border rounded-lg pl-10 pr-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
        />
      </div>

      {/* Security Reminder */}
      <div className="flex items-center gap-2 text-yellow-600 text-sm font-medium">
        <FaBullhorn />
        <span>Account Security Reminder</span>
      </div>

      {/* Improve Security Card */}
      <div className="border rounded-lg p-4 shadow-sm">
        <h3 className="font-semibold text-base">
          Improve Account Security
        </h3>
        <p className="text-sm mt-2">
          Enable at least 3 verification methods to ensure smooth online 2FA
          reset and enhance account security for crypto withdrawal/deposit and
          P2P trading.
        </p>
        <button className="mt-4 w-full bg-yellow-400 hover:bg-yellow-500 text-black font-medium py-2 rounded-lg transition">
          How to Enable
        </button>
      </div>

      {/* You might be looking for */}
      <div>
        <h3 className="font-semibold text-base mb-3">
          You might be looking for
        </h3>
        <ul className="list-none space-y-2 text-sm">
          <li className="text-yellow-600 hover:underline cursor-pointer">
            Complete August’s Challenge to Share Points & Unlock Exclusive Rewards!
          </li>
          <li className="text-yellow-600 hover:underline cursor-pointer">
         Wallet: Join the Exclusive TGE with RICE AI
          </li>
          <li className="text-yellow-600 hover:underline cursor-pointer">
            Join the Spot Altcoin Trading Festival
          </li>
          <li className="text-yellow-600 hover:underline cursor-pointer">
            I want to check latest Alpha airdrop
          </li>
        </ul>
      </div>

      {/* Self Service */}
      <div>
        <h3 className="font-semibold text-base mb-4">
          Self Service
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Card 1 */}
          <div className="border rounded-lg p-4 shadow-sm hover:shadow-md transition cursor-pointer">
            <div className="flex items-center gap-3">
              <FaUserSlash className=" text-xl" />
              <div>
                <h4 className="font-medium text-sm">
                  Disable Account
                </h4>
                <p className="text-gray-600 text-xs">
                  Request to manually disable account
                </p>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="border rounded-lg p-4 shadow-sm hover:shadow-md transition cursor-pointer">
            <div className="flex items-center gap-3">
              <FaExclamationTriangle className=" text-xl" />
              <div>
                <h4 className="font-medium text-sm">
                  Appeal KYC Rejection
                </h4>
                <p className="text-gray-600 text-xs">
                  Request review of verification rejection.
                </p>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="border rounded-lg p-4 shadow-sm hover:shadow-md transition cursor-pointer">
            <div className="flex items-center gap-3">
              <FaExchangeAlt className=" text-xl" />
              <div>
                <h4 className="font-medium text-sm">
                  Lift P2P Suspension
                </h4>
                <p className="text-gray-600 text-xs">
                  Review inappropriate P2P trade suspensions.
                </p>
              </div>
            </div>
          </div>

          {/* Card 4 */}
          <div className="border rounded-lg p-4 shadow-sm hover:shadow-md transition cursor-pointer">
            <div className="flex items-center gap-3">
              <FaCoins className=" text-xl" />
              <div>
                <h4 className="font-medium text-sm">
                  Crypto Deposit Not Arrived
                </h4>
                <p className="text-gray-600 text-xs">
                  Crypto Deposit not credited to account.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 

export default ChatSupport;
